import { render, staticRenderFns } from "./Horse.vue?vue&type=template&id=34cd1ead&scoped=true&"
import script from "./Horse.vue?vue&type=script&lang=js&"
export * from "./Horse.vue?vue&type=script&lang=js&"
import style0 from "./Horse.vue?vue&type=style&index=0&id=34cd1ead&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cd1ead",
  null
  
)

export default component.exports